import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, HostListener, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, take, takeUntil } from 'rxjs/operators';
import { FilterValue } from '../../../../app/interfaces/base/filter-value';
import { FormControl } from '@angular/forms';
import { ApiService } from '../../../../app/services/base/api.service';
import { TableAutocompleteSearchResults } from '../../../../app/interfaces/base/table-autocomplete-search-results';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';

@Component({
  selector: 'fury-table-filter-autocomplete',
  templateUrl: './table-filter-autocomplete.component.html',
  styleUrls: ['./table-filter-autocomplete.component.scss']
})
export class TableFilterAutocompleteComponent implements AfterViewInit, OnDestroy {

  public isFiltered: boolean = false;

  @Input() name: string = null;

  @Input() customFiltering: boolean = false;
  @Output() clearFilter: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() filterChange: EventEmitter<string> = new EventEmitter<string>();

  @ViewChild('filterAutocompleteTrigger', {read: MatAutocompleteTrigger}) filterAutocompleteTrigger: MatAutocompleteTrigger;

  public element: FormControl = new FormControl<string>('');
  public isLoading: boolean = false;

  public suggestionString: TableAutocompleteSearchResults = null;
  public suggestionTypes: TableAutocompleteSearchResults[] = [];
  public suggestionCompanies: TableAutocompleteSearchResults[] = [];

  private suggestionSubscription: Subscription = null;
  private destroy$: Subject<null> = new Subject<null>();

  constructor(private api: ApiService,
              private cd: ChangeDetectorRef
  ) {
  }

  @HostListener('keydown.space', ['$event'])
  @HostListener('click', ['$event']) onClick(e: Event): void {
    e.stopPropagation();
  }

  ngAfterViewInit(): void {
    this.element.valueChanges.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      filter((q: string | object): boolean | null => (typeof q === 'string' ? q && q.length > 2 : typeof q === 'object')),
      takeUntil(this.destroy$)
    ).subscribe((value: string | TableAutocompleteSearchResults): void => {
      if (typeof value === 'string') {
        this.suggestionTypes = [];
        this.suggestionCompanies = [];

        this.suggestionString = {
          id: <string>value,
          name: <string>value
        };

        this.isLoading = true;
        if (this.suggestionSubscription !== null) {
          this.suggestionSubscription.unsubscribe();
        }
/*
        this.suggestionSubscription = this.filtersService.companiesWithTypes(value).pipe(takeUntil(this.destroy$)).subscribe((data: TableAutocompleteSearchResults[]): void => {
            if (data.length) {
              data.forEach((d: TableAutocompleteSearchResults): void => {
                if (d.type === 'company') {
                  this.suggestionCompanies.push(d);
                } else if (d.type === 'type') {
                  this.suggestionTypes.push(d);
                }
              });
            }

            this.isLoading = false;
            this.cd.detectChanges();
          },
          (): void => {
            this.isLoading = false;
            this.cd.detectChanges();
          });
*/
      } else {
        this.isFiltered = !!value;

        if (this.customFiltering) {
          (value ? this.filterChange.emit(value.name) : this.clearFilter.next());
        } else {
          (value ? this.api.setFilter(this.name, value.name) : this.api.clearFilter(this.name));
        }
      }
    });


    this.api.preSetFilters.pipe(
      take(1),
      takeUntil(this.destroy$)
    ).subscribe((filters: FilterValue[]): void => {
      filters.forEach((key: FilterValue): void => {
        if (this.name === key.name) {
          this.isFiltered = !!key.value;

          if (key.value) {
            this.element.setValue(key.value, {emitEvent: false});
          }

          this.cd.detectChanges();
        }
      });
    });

    this.api.filterCleared.pipe(takeUntil(this.destroy$)).subscribe((): void => this.clearFilterButton());
    this.api.clearAllFilters.pipe(takeUntil(this.destroy$)).subscribe((): void => this.clearFilterButton(false));
  }

  formatAutocomplete(result: any): string {
    return result !== null && typeof result === 'object' ? result.name : result;
  }

  clearFilterButton(emitEvent: boolean = true): void {
    this.element.setValue('', {emitEvent: false});
    this.isFiltered = false;
    this.suggestionString = null;
    this.suggestionTypes = [];
    this.suggestionCompanies = [];

    if (this.filterAutocompleteTrigger !== null) {
      this.filterAutocompleteTrigger.closePanel();
    }

    if (emitEvent) {
      if (this.customFiltering) {
        this.clearFilter.next();
      } else {
        this.api.clearFilter(this.name);
      }
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();

    if (this.suggestionSubscription !== null) {
      this.suggestionSubscription.unsubscribe();
    }
  }
}
